import React, { useState, useEffect } from 'react';
import JoinWaitlist from '../JoinWaitlist/JoinWaitlist';
import './LandingPage.css';
import { FaGithub, FaSlack } from 'react-icons/fa';
import { SiJira, SiNotion } from 'react-icons/si';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";

function LandingPage() {
  const [showModal, setShowModal] = useState(false);
  const [showNavMenu, setShowNavMenu] = useState(false);
  const [waitlistCount, setWaitlistCount] = useState(null);

  useEffect(() => {
    const fetchWaitlistCount = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "waitlist"));
        setWaitlistCount(querySnapshot.size);
      } catch (error) {
        console.error("Error fetching waitlist count:", error);
      }
    };

    fetchWaitlistCount();
  }, []);

  return (
    <>
      <div className="lp-page">
        <div className="lp-ambient lp-ambient-a" />
        <div className="lp-ambient lp-ambient-b" />

        <header className="lp-nav">
          <div className="lp-brand-wrap">
            <span className="lp-brand-text">Foppr</span>
          </div>
          <div className="lp-nav-actions">
            <span className="lp-nav-copy">For teams building at startup speed</span>
            <button
              className="lp-hamburger"
              type="button"
              aria-label="Open navigation menu"
              onClick={() => setShowNavMenu((prev) => !prev)}
            >
              <span />
              <span />
              <span />
            </button>
            <button className="lp-btn lp-btn-dark" onClick={() => setShowModal(true)}>
              Join Waitlist
            </button>
            {showNavMenu && (
              <div className="lp-menu-panel">
                <a href="#how-it-works" onClick={() => setShowNavMenu(false)}>How It Works</a>
                <button
                  type="button"
                  onClick={() => {
                    setShowNavMenu(false);
                    setShowModal(true);
                  }}
                >
                  Join Waitlist
                </button>
                <button type="button" onClick={() => setShowNavMenu(false)}>
                  {waitlistCount !== null
                    ? `${waitlistCount.toLocaleString()}+ builders waiting`
                    : 'Early access cohort open'}
                </button>
              </div>
            )}
          </div>
        </header>

        <main>
          <section className="hero-grid">
            <div className="hero-left fade-up">
              <p className="hero-kicker">Foppr Matching Engine</p>
              <h1 className="hero-title">
                <span className="hero-title-line">AI agents that find your next</span>
                <span className="hero-rotate-wrap" aria-label="Co-founder, Builder, Collaborator, Teammate, Startup partner">
                  <span className="hero-rotate-track" aria-hidden="true">
                    <span>Co-founder</span>
                    <span>Builder</span>
                    <span>Collaborator</span>
                    <span>Teammate</span>
                    <span>Startup partner</span>
                    <span>Co-founder</span>
                  </span>
                </span>
                <span className="hero-title-line">based on execution, not networking.</span>
              </h1>
              <p className="hero-subtitle">
                We match you with the right person to help you ship — based on what you've built, not who you know.
              </p>

              <div className="hero-cta">
                <button className="lp-btn lp-btn-primary" onClick={() => setShowModal(true)}>
                  Get Early Access
                </button>
                <a href="#how-it-works" className="lp-btn lp-btn-ghost">
                  See how it works
                </a>
              </div>

              <div className="hero-proof">
                <div className="proof-avatars" aria-hidden="true">
                  <span>NK</span>
                  <span>AR</span>
                  <span>PL</span>
                </div>
                <div className="proof-copy">
                  {waitlistCount !== null ? `${waitlistCount.toLocaleString()}+ builders` : 'Growing fast'} already on the waitlist
                </div>
              </div>
            </div>

            <div className="hero-right fade-up-delayed">
              <article className="signal-card">
                <p className="signal-label">Matching Signal</p>
                <h3>Precision Partnering</h3>
                <div className="signal-score-row">
                  <span>Compatibility score</span>
                  <strong>97%</strong>
                </div>
                <div className="signal-bar">
                  <div className="signal-bar-fill" />
                </div>
                <ul className="signal-points">
                  <li>Aligned weekly velocity</li>
                  <li>Complementary skill stack</li>
                  <li>Shared accountability rhythm</li>
                </ul>
              </article>

              <article className="metric-card">
                <p>Partners matched</p>
                <div className="metric-value">
                  {waitlistCount !== null ? waitlistCount.toLocaleString() : '—'}
                </div>
                <span>Updated live from onboarding pipeline</span>
              </article>

              <div className="metric-integrations">
                <span className="metric-integrations-label">Integrates with</span>
                <div className="metric-integrations-logos" aria-label="Integrations">
                  <span><FaGithub aria-hidden="true" /> GitHub</span>
                  <span><FaSlack aria-hidden="true" /> Slack</span>
                  <span><SiJira aria-hidden="true" /> Jira</span>
                  <span><SiNotion aria-hidden="true" /> Notion</span>
                </div>
              </div>
            </div>
          </section>

          <section className="trust-strip">
            <p>Designed for operators, founders, and ambitious builders who value compounding progress.</p>
          </section>

          <section id="how-it-works" className="how-grid">
            <article className="how-card">
              <p>01</p>
              <h4>Profile your edge</h4>
              <span>Capture your goals, intensity, and preferred collaboration style in under 3 minutes.</span>
            </article>
            <article className="how-card">
              <p>02</p>
              <h4>Agent-led matching</h4>
              <span>Our engine scores compatibility on pace, outcomes, and communication patterns.</span>
            </article>
            <article className="how-card">
              <p>03</p>
              <h4>Ship with momentum</h4>
              <span>Start with a focused sprint plan and measurable checkpoints from day one.</span>
            </article>
          </section>

          <section className="final-cta">
            <h2>Build faster with the right person beside you.</h2>
            <button className="lp-btn lp-btn-primary" onClick={() => setShowModal(true)}>
              Reserve my spot
            </button>
          </section>
        </main>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="waitlist-modal">
            <button className="close-btn" onClick={() => setShowModal(false)} aria-label="Close waitlist form">×</button>
            <JoinWaitlist onClose={() => setShowModal(false)} />
          </div>
        </div>
      )}
    </>
  );
}

export default LandingPage;
